export const BellIcon = ({ className, color = "currentColor" }: { className?: string; color?: string }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M7.79167 17.5C8.21452 17.8045 8.72536 17.9693 9.25 17.9693C9.77464 17.9693 10.2855 17.8045 10.7083 17.5M14.25 6.66667C14.25 5.34058 13.7232 4.06881 12.7855 3.13113C11.8478 2.19345 10.5761 1.66667 9.25 1.66667C7.92392 1.66667 6.65215 2.19345 5.71447 3.13113C4.77678 4.06881 4.25 5.34058 4.25 6.66667C4.25 9.24183 3.58333 11.005 2.86667 12.1117C2.25933 13.0483 1.95567 13.5167 1.96667 13.6417C1.979 13.7817 2.00567 13.8283 2.11833 13.9133C2.21833 13.9883 2.69433 13.9883 3.64633 13.9883H14.8537C15.8057 13.9883 16.2817 13.9883 16.3817 13.9133C16.4943 13.8283 16.521 13.7817 16.5333 13.6417C16.5443 13.5167 16.2407 13.0483 15.6333 12.1117C14.9167 11.005 14.25 9.24183 14.25 6.66667Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
